// 在重构稿基础上开发的组件
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col } from 'tea-component';
import moment from 'moment';
import useComConstants from '../../_config/comConstants.js';
import SplashesChat from '@/pages/dashboard/components/SplashesChat';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import {
  exportExcel,
  buildExcelColumns,
  formatNum,
  formatPercentNum,
  formatExeclNum,
  formatExeclNormalPercent,
  formatExeclCommon,
  isValNull,
} from '@/pages/dashboard/utils/utils';
import { useRequest } from '@/pages/dashboard/utils/customHook';
import {
  getInsightRentention,
  getInsightRevenue,
} from '@/pages/dashboard/services/competitor';
import CardSlot from '@/pages/dashboard/components/CardSlot/index';
import { rightIcon } from '@/pages/dashboard/pages/competitor/_config/constants';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import './index.less';
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';
import { competitorRequest } from '@/pages/dashboard/pages/competitor/_config/competitorRequest';

const RANGE_DATE_KEY_MAP = {
  date: 'Day',
  week: 'Week',
  month: 'Month',
} as any;

const Competitive = (props) => {
  const { formValue, gameCode, filterLoading, competitorReqType } = props;
  const { isEN, locale, getLocalText } = useLocal();
  const {
    REVENUE_ACTIVE_COLUMNS,
    NEW_RETENTION_D2_COLUMNS,
    REVENUE_ACTIVE_COLUMNS_SUM,
  } = useComConstants();
  const { isLaunchTime = false, isEarliestData = false, filterValue: newFilterValue = {} } =
    formValue ?? {};
  const { rangeTime, rangeDayMonth, region, system, source, competitor } =
    newFilterValue;
  const { type: launchTimeType, value: launchTime } = rangeDayMonth ?? {};
  let { type: timeType, value: rangeDate } = rangeTime ?? {};
  timeType = RANGE_DATE_KEY_MAP[timeType];

  const [action, setAction] = useState('discount-chart');
  const [action1, setAction1] = useState('discount-chart');
  const [revenue, setRevenue] = useState();
  const [activeTab, setActiveTab] = useState('earch-other');
  const [activeTab2, setActiveTab2] = useState('earch-other');
  const [retention, setRetention] = useState();
  const {
    sendRequest: sendRevenueRequest,
    isLoading: isRevenueLoading,
    isError: isRevenueError,
  } = useRequest();
  const {
    sendRequest: sendRetentionRequest,
    isLoading: isRetentionLoading,
    isError: isRetentionError,
  } = useRequest();
  // competitor_insight_competitive_comparison_module1_Ylable
  useEffect(() => {
    if (filterLoading) return;
    if (formValue?.filterValue?.competitor?.length > 0) {
      fetchData({
        isLaunchTime,
        isEarliestData,
        timeType,
        competitor,
        region,
        system,
        source,
      });
    }
  }, [formValue, filterLoading]);

  const fetchData = (formValue: any) => {
    const { isLaunchTime, isEarliestData, timeType, competitor, region, system, source } =
      formValue;
    const timeObj = {
      Day: 'daily',
      Week: 'weekly',
      Month: 'monthly',
    };
    const newType = ((isLaunchTime || isEarliestData) ? launchTimeType : timeType) || 'Day';
    const newTime = (isLaunchTime || isEarliestData) ? launchTime : rangeDate;

    const newFormValue = {
      game_code: gameCode,
      is_launch_time: isEarliestData ? false : isLaunchTime,
      is_earliest_time: isEarliestData,
      period: timeObj[newType],
      start_time: newTime[0],
      end_time: newTime[1],
      filters: {
        competitor_list: competitor,
        market_list: region.markets,
        os_list: system,
        source,
      },
    };
    getRevenue(newFormValue);
    getRetention(newFormValue);
  };

  const getRevenue = async (param) => {
    try {
      const res = await sendRevenueRequest(competitorRequest.getInsightRevenue[competitorReqType](param));
      setRevenue(res);
    } catch (error) {
      console.log(error)
    }
  };

  const getRetention = async (param) => {
    try {
      const res = await sendRetentionRequest(competitorRequest.getInsightRentention[competitorReqType](param));
      setRetention(res);
    } catch (error) {
      console.log(error)
    }
  };

  // 下载
  const handleDownload = (title, option, data) => {
    const name = title?.replace(/\u0020/g, '_');
    const excelColumn = buildExcelColumns(option?.length ?? 0);
    // 表头行
    const headerRow = {};
    // 表头顺序
    const header: string[] = [];
    // 以 key 为顺序
    const keys: string[] = [];

    option?.forEach((item) => {
      header.push(item.header);
      keys.push(item.key);
    });
    header?.forEach((item, index) => {
      headerRow[excelColumn[index]] = item;
    });
    const excelData = [headerRow];

    data?.forEach((item) => {
      const itemData = {};
      keys?.forEach((key, index) => {
        itemData[excelColumn[index]] = item[key];
      });
      excelData.push(itemData);
    });
    // 导出excel
    exportExcel(name, excelData);
  };
  // echarts数据处理
  const handleData = (Cdata, isNew) => {
    if (!Cdata) return;
    const xkey = isNew ? 'new' : 'active';
    const ykey = isNew ? 'd2' : 'revenue';
    // 根据这里查找name 和 cover
    const { current, previous } = Cdata;
    const data = previous?.map((item) => {
      const index = competitor?.findIndex(
        (v) => v.unified_id === item.unified_id,
      );
      return {
        name: competitor[index]?.name,
        value: item[xkey] || +item[ykey] ? [+item[xkey], +item[ykey]] : null,
        symbolSize: [25, 25],
        itemStyle: { opacity: 0.5 },
        symbol: `image://${competitor[index]?.cover_url}`,
      };
    });
    current?.forEach((item) => {
      const index = competitor?.findIndex(
        (v) => v.unified_id === item.unified_id,
      );
      data.push({
        name: competitor[index]?.name,
        value: item[xkey] || +item[ykey] ? [+item[xkey], +item[ykey]] : null,
        symbolSize: [25, 25],
        symbol: `image://${competitor[index]?.cover_url}`,
      });
    });
    return data;
  };
  // table数据处理
  const handleTable = (Cdata, isNew, isDownload = false) => {
    if (!Cdata) return;
    const xkey = isNew ? 'new' : 'active';
    const ykey = isNew ? 'd2' : 'revenue';
    const { current, previous } = Cdata;

    if (!isDownload) {
      if (isNew) {
        const data = current?.map((item) => {
          const index = previous.findIndex(
            (v) => v.unified_id === item.unified_id,
          );
          const cIndex = competitor?.findIndex(
            (v) => v.unified_id === item.unified_id,
          );
          return {
            game: competitor?.[cIndex]?.name,
            new: formatNum(item[xkey], false, true),
            previousNew: formatNum(previous[index][xkey], false, true),
            D2: formatPercentNum(item[ykey]),
            previousD2: formatPercentNum(previous[index][ykey]),
          };
        });
        return data;
      }

      const data = current?.map((item) => {
        const index = previous.findIndex(
          (v) => v.unified_id === item.unified_id,
        );
        const cIndex = competitor?.findIndex(
          (v) => v.unified_id === item.unified_id,
        );
        return {
          game: competitor?.[cIndex]?.name,
          active: formatNum(item[xkey], false, true),
          previousActive: formatNum(previous[index][xkey], false, true),
          revenue: formatNum(item[ykey]),
          previousRevenue: formatNum(previous[index][ykey]),
        };
      });

      return data;
    } else {
      if (isNew) {
        const data = current?.map((item) => {
          const index = previous.findIndex(
            (v) => v.unified_id === item.unified_id,
          );
          const cIndex = competitor?.findIndex(
            (v) => v.unified_id === item.unified_id,
          );
          return {
            game: competitor?.[cIndex]?.name,
            new: formatExeclNum(item[xkey]),
            previousNew: formatExeclNum(previous[index][xkey]),
            D2: formatExeclNormalPercent(item[ykey]),
            previousD2: formatExeclNormalPercent(previous[index][ykey]),
          };
        });
        return data;
      }

      const data = current?.map((item) => {
        const index = previous.findIndex(
          (v) => v.unified_id === item.unified_id,
        );
        const cIndex = competitor?.findIndex(
          (v) => v.unified_id === item.unified_id,
        );
        return {
          game: competitor?.[cIndex]?.name,
          active: formatExeclNum(item[xkey]),
          previousActive: formatExeclNum(previous[index][xkey]),
          revenue: formatExeclCommon(item[ykey]),
          previousRevenue: formatExeclCommon(previous[index][ykey]),
        };
      });

      return data;
    }
  };
  // 表头根据时间选择
  const handleTime = () => {
    const star = rangeDate?.[0];
    const end = rangeDate?.[1];
    const newType = timeType?.toLowerCase();
    if (newType !== 'week') return moment(star).isSame(end, newType);
    if (moment(end).week() - moment(star).week() === 1) return true;
    return false;
  };
  const newRevenue = useMemo(() => handleData(revenue, false), [revenue]);
  const tableRevenue = useMemo(() => handleTable(revenue, false), [revenue]);
  const tableDownloadRevenue = useMemo(
    () => handleTable(revenue, false, true),
    [revenue],
  );
  const newRetention = useMemo(() => handleData(retention, true), [retention]);

  const tableRetention = useMemo(
    () => handleTable(retention, true),
    [retention],
  );
  const tableDownloadRetention = useMemo(
    () => handleTable(retention, true, true),
    [retention],
  );
  const isNoMoreTime = handleTime();

  return (
    <>
      <div className="dbd-insight-title">
        <span className="dbd-insight-text">
          {getLocalText('competitor_insight_competitive_comparison_title')}
        </span>
        <span className="dbd-insight-time">
          {!filterLoading
            ? new Set(rangeDate).size === 1
              ? rangeDate?.[0]
              : rangeDate?.[0] + '~' + rangeDate?.[1]
            : ''}
        </span>
      </div>
      <Row>
        <Col span={12}>
          <CardSlot
            isEyes={true}
            title={getLocalText(
              'competitor_insight_competitive_comparison_module1_title',
              { unit: getMonetUnit() }
            )}
            iconShow={
              isRevenueLoading ||
              isRevenueError ||
              isValNull(newRevenue, 'value')
            }
            activeTab={activeTab}
            iconList={rightIcon}
            getChange={(value: any) => {
              setAction(value);
              setActiveTab(value);
            }}
            onDownload={() =>
              handleDownload(
                getLocalText(
                  'competitor_insight_competitive_comparison_module1_title',
                  { unit: getMonetUnit() }
                ),
                isNoMoreTime
                  ? REVENUE_ACTIVE_COLUMNS
                  : REVENUE_ACTIVE_COLUMNS_SUM,
                tableDownloadRevenue,
              )
            }
          >
            {
              <Abnormal
                isLoading={isRevenueLoading}
                isError={isRevenueError}
                isNoData={isValNull(newRevenue, 'value')}
                style={{ height: 450 }}
                component={
                  action == 'sheet' ? (
                    <MiniTable
                      loading={false}
                      tableOption={
                        isNoMoreTime
                          ? REVENUE_ACTIVE_COLUMNS
                          : REVENUE_ACTIVE_COLUMNS_SUM
                      }
                      tableList={tableRevenue}
                      height={450}
                      className="dbd-competitor-mini-table"
                    />
                  ) : (
                    <SplashesChat
                      key={locale + 'Revenue($) & Active'}
                      xTitle={getLocalText(
                        'competitor_insight_competitive_comparison_module1_x_lable',
                      )}
                      yTitle={getLocalText(
                        'competitor_insight_competitive_comparison_module1_y_lable',
                      )}
                      height={450}
                      chartData={newRevenue}
                    />
                  )
                }
              />
            }
          </CardSlot>
        </Col>
        <Col span={12}>
          <CardSlot
            isEyes={true}
            iconShow={
              timeType !== 'Month' ||
              source === 'ogdb' ||
              isRetentionLoading ||
              isRetentionError ||
              !newRetention?.length
            }
            activeTab={activeTab2}
            title={getLocalText(
              'competitor_insight_competitive_comparison_module2_title',
            )}
            iconList={rightIcon}
            getChange={(value: any) => {
              setAction1(value);
              setActiveTab2(value);
            }}
            onDownload={() =>
              handleDownload(
                getLocalText(
                  'competitor_insight_competitive_comparison_module2_title',
                ),
                NEW_RETENTION_D2_COLUMNS,
                tableDownloadRetention,
              )
            }
          >
            {
              <Abnormal
                isLoading={isRetentionLoading}
                isError={isRetentionError}
                isNoData={isValNull(newRetention, 'value')}
                nodataMsg={getLocalText(
                  'competitor_insight_competitive_comparison_module2_no_data',
                )}
                style={{ height: 450 }}
                component={
                  timeType !== 'Month' || source === 'ogdb' ? (
                    <div
                      className="dbd-type-text"
                      dangerouslySetInnerHTML={{
                        __html: `${getLocalText(
                          'competitor_insight_competitive_comparison_module2_no_data',
                        )}`,
                      }}
                    ></div>
                  ) : action1 == 'sheet' ? (
                    <MiniTable
                      loading={false}
                      tableOption={NEW_RETENTION_D2_COLUMNS}
                      tableList={tableRetention}
                      height={450}
                    />
                  ) : (
                    <SplashesChat
                      key={locale + 'New & Retention D2'}
                      xTitle={getLocalText(
                        'competitor_insight_competitive_comparison_module2_x_lable',
                      )}
                      yTitle={getLocalText(
                        'competitor_insight_competitive_comparison_module2_y_lable',
                      )}
                      height={450}
                      chartData={newRetention}
                    />
                  )
                }
              />
            }
          </CardSlot>
        </Col>
      </Row>
    </>
  );
};

export default Competitive;
